import type {
  ApiKeyUsageGroupBy,
  ApiKeyUsageRow,
  ThirdPartyUsageGroupBy,
  ThirdPartyUsageRow,
} from '../../types';

export function defaultUsageFromDate(): string {
  const date = new Date();
  date.setDate(date.getDate() - 30);
  return date.toISOString().slice(0, 10);
}

export function defaultUsageToDate(): string {
  return new Date().toISOString().slice(0, 10);
}

export const API_KEY_USAGE_GROUPS: ApiKeyUsageGroupBy[] = ['api_key', 'capability', 'agent', 'day'];

export function apiKeyUsageRowLabel(row: ApiKeyUsageRow, groupBy: ApiKeyUsageGroupBy): string {
  if (groupBy === 'agent') return row.agent_public_id || 'owner-level';
  if (groupBy === 'day') return row.day || 'unknown-day';
  if (groupBy === 'capability') return row.capability || 'unknown-capability';
  return row.api_key_public_id || (row.api_key_id ? `API key #${row.api_key_id}` : 'unknown-key');
}

export const THIRD_PARTY_USAGE_GROUPS: ThirdPartyUsageGroupBy[] = [
  'external_tenant',
  'agent',
  'day',
  'api_key',
  'capability',
  'tool',
];

export function usageRowLabel(row: ThirdPartyUsageRow, groupBy: ThirdPartyUsageGroupBy): string {
  if (groupBy === 'agent') return row.agent_public_id || 'unknown-agent';
  if (groupBy === 'day') return row.day || 'unknown-day';
  if (groupBy === 'api_key') return row.api_key_id ? `API key #${row.api_key_id}` : 'unknown-key';
  if (groupBy === 'capability') return row.capability || 'unknown-capability';
  if (groupBy === 'tool') return row.tool_id || 'unknown-tool';
  return row.external_tenant_id || row.client_id || 'unknown-tenant';
}
